var map = {
	"./ayur.jpg": 9737,
	"./cardio.jpg": 2468,
	"./dentistry.jpg": 218,
	"./derma.jpg": 491,
	"./diabet.jpg": 8097,
	"./endocrino.jpg": 1099,
	"./ent.jpg": 6475,
	"./gastro.jpg": 486,
	"./gen-phy.jpg": 2984,
	"./gynae.jpg": 1100,
	"./homeo.jpg": 6368,
	"./neuro.jpg": 8733,
	"./ophthalmo.jpg": 3624,
	"./ortho.jpg": 846,
	"./peadia.jpg": 7286,
	"./physio.jpg": 5386,
	"./psych.jpg": 5897,
	"./pulmono.jpg": 3562,
	"./rheumato.jpg": 3211,
	"./sexo.jpg": 7121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9560;